export const FormEndpoint = "";
export const CompanyName = "";

export const CompanyInfo = Object.freeze({
    name: "Gyrfalcon S.R.O.",
    address: 'Krakovska 583/9, 110 00 Prague, Czech Republic',
    companyId: '',
    vatId: '',
    email: 'office@gyrfalcon.cz',
    phone: ''
});